import { toast } from 'react-toastify';
import check from '../assets/icons/circle-check-sharp-solid.svg';
import cross from '../assets/icons/circle-xmark-sharp-solid.svg';
import { toastStyles } from '../enums/toast.enum';
import { errorToastId, pendingToastId } from '../constants';

interface toastHandlerArgs {
	isError?: boolean;
	msg: string;
	isLoading?: boolean;
}

export const toastHandler = ({
	isError,
	msg,
	isLoading = false,
}: toastHandlerArgs) => {
	toast.dismiss({ containerId: pendingToastId });
	if (isLoading) {
		toast.loading(msg, { delay: 100, containerId: pendingToastId });
		return;
	}
	if (isError) {
		toast.error(msg, {
			containerId: errorToastId,
			icon: <img src={cross} />,
			progressStyle: {
				background: toastStyles.errorColor,
			},
		});
	} else {
		toast.success(msg, {
			icon: <img src={check} alt="icon" />,
			delay: 100,
			progressStyle: {
				background: toastStyles.successColor,
			},
		});
	}
};
